import(/* webpackMode: "eager" */ "/codebuild/output/src3136774224/src/dc-lms-customer-website/src/components/TeachingPage/page.jsx")